import { QueryConfig, QueryResult } from '@tanstack/react-query';

import { Path } from '@openclassrooms/sdk-web';

import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: usePath, useFind: usePaths } = getCRUDHooks({
  entityName: 'paths',
}) as {
  useGet: ({ id }: { id: number }, queryOptions?: QueryConfig<Path>) => QueryResult<Path>;
  useFind: (filters: {
    filters: {
      searchParams: {
        fundingMechanismType?: 'apprenticeship' | 'scholarship';
        'life-cycle-status'?: 'active-or-archived' | 'archived';
        eligibleCountry?:
          | 'FR'
          | 'RE'
          | 'GP'
          | 'MQ'
          | 'PF'
          | 'GF'
          | 'YT'
          | 'NC'
          | 'BL'
          | 'PM'
          | 'WF'
          | 'UK'
          | 'US'
          | 'BE';
      };
    };
  }) => QueryResult<Path[]>;
};

export { usePath, usePaths };
